import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React from 'react';
import { ActiveOrdersTable } from '@thd-olt-component-react/phx-tables';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  useCommonContext,
  usePurchaseHistoryContext,
} from '../../hooks/useContexts';
import {
  ICardAndTableView,
  IOrderHistoryResponse,
} from '../../models/purchase-history';
import { ITableView } from '../../models/purchase-history/table';
import { PHCardView } from './card-view/PHCardView';
import { PHTable } from './table-view/PHTable';

export const CardAndTableView = ({
  orderHistoryModalHooks,
  enableSettingsDrawer,
  setEnableSettingsDrawer,
}: ICardAndTableView) => {
  const { isMobile } = useCommonContext();
  const {
    customerRole,
    customerType,
    orderHistoryData,
    orderHistoryLoaded,
    pHRequest,
    setAlertState,
    setPHRequest,
    viewType,
  } = usePurchaseHistoryContext();

  const TableViewProps: ITableView = {
    customerRole,
    customerType,
    orderHistoryData: orderHistoryData as IOrderHistoryResponse,
    orderHistoryLoaded,
    orderHistoryModalHooks,
    pHRequest,
    setAlertState,
    setPHRequest,
    enableSettingsDrawer,
    setEnableSettingsDrawer,
  };

  if (viewType === 'Card' || isMobile || customerType === 'b2c') {
    return (
      <>
        <ErrorBoundary name="order-card-view">
          <PHCardView customerRole={customerRole} customerType={customerType} />
        </ErrorBoundary>
      </>
    );
  }

  if (viewType === 'activeOrders') {
    return (
      <>
        <ErrorBoundary name="active-orders-table">
          <QueryProvider cacheKey="active-orders-table">
            <ActiveOrdersTable />
          </QueryProvider>
        </ErrorBoundary>
      </>
    );
  }

  return (
    <ErrorBoundary name="table-view">
      <PHTable {...TableViewProps} />
    </ErrorBoundary>
  );
};
